module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<fieldset class="monoTypeView cw-fieldset">\r\n    <div class="firstLine form-row">\r\n        <div class="buttonsContainer form-group">\r\n            <div class="supprimerButtons"></div>\r\n        </div>\r\n    </div>\r\n    <div class="tableMonoType"></div>\r\n</fieldset>';
}
return __p;
};
